import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { isValidPositiveMoneyValue } from "../../../../utilities/is-valid-money";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";

export interface EditShiftClosureFloatScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "EditShiftClosureFloatScreen"
  > {}

export const EditShiftClosureFloatScreen = ({
  navigation,
}: EditShiftClosureFloatScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { defaultTerminalClosureFloat } = globalSettings;
  const [value, setValue] = useState(defaultTerminalClosureFloat.toString());

  const isDirty = useMemo(() => {
    return value !== defaultTerminalClosureFloat.toString();
  }, [value, defaultTerminalClosureFloat]);

  const isValid = useMemo(() => {
    return isValidPositiveMoneyValue(value);
  }, [value]);

  const handleOnSave = useCallback(async () => {
    return updateGlobalSettings({
      defaultTerminalClosureFloat: parseFloat(value),
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label="Edit Default Shift Float" />,
      headerStatusBarHeight: 10,

      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Default shift float"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
        formatterType={isValid ? "money" : undefined}
        validationMessage={
          isValid ? undefined : "Please enter a valid money value"
        }
      />
    </Page>
  );
};
